module.exports = __webpack_public_path__ + "img/6ff26ac.png";